// extracted by mini-css-extract-plugin
export default {"imagesWrapper":"AI-z"};